export default "__VITE_ASSET__1AtBsw$F__"